import { render, staticRenderFns } from "./ICCube.vue?vue&type=template&id=9b1ce252&scoped=true"
import script from "./ICCube.vue?vue&type=script&lang=js"
export * from "./ICCube.vue?vue&type=script&lang=js"
import style0 from "./ICCube.vue?vue&type=style&index=0&id=9b1ce252&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1ce252",
  null
  
)

export default component.exports